import React from 'react';
import Order from "./Order";

function ReOrder() {
  return (
      <Order reorder={true} />
  );
}

export default ReOrder;